import CusMultipleFilter from 'components/CusMultipleFilter';
import useMain from 'hooks/useMain';
import moment from 'moment';
import React from 'react';
import { micService } from 'services/mic';
import {
  downloadExcel,
  downloadPDF,
  getProject,
  handleAlertMessage,
  handleAsyncCall,
  OptionUtils,
  transferPdfBufferToSrc
} from 'utils/common';

const Summary = () => {
  const { t, useSelector, upperCaseLang } = useMain();
  const bcTypes = useSelector((state) => state.comModule.bcTypes);
  const bcTypeOptions = OptionUtils.localizeBctypeOptions(bcTypes, upperCaseLang);
  return (
    <CusMultipleFilter
      title={t('EXPORT_REPORT')}
      filters={[
        {
          id: 'Bctype',
          label: t('BC_TYPE'),
          type: 'select',
          options: bcTypeOptions
        }
      ]}
      buttonLabel={t('EXPORT')}
      handleSubmit={(data) => {
        if (data?.Bctype) {
          handleAsyncCall({
            service: micService.getBcReport,
            params: {
              projid: getProject().ProjId,
              bctype: data.Bctype,
              lang: upperCaseLang
            },
            successCb: (res) => downloadExcel(res.data, `BCMS Summary Report (${data?.Bctype}) ${moment(new Date()).format('YYYYMMDD')}`)
          });
          return;
        }

        handleAlertMessage({
          text: 'Please Select BC Type',
          showCancelButton: false
        });
      }}
    />
  );
};

export default Summary;
